import { Component } from "react";
import { withRouter } from "next/router";
import { connect } from "react-redux";
import { withStyles } from "react-jss";
import moment from "moment-timezone";
import { getShopsAppByDescriptor } from "../../../redux/api/actions";
import { setDefaultOfferCode } from "../../../redux/features/actions";
import redirect from "../../../utils/redirect";
import setCookieAndLoadProfile from "../../../utils/setCookieAndLoadProfile";
import loadBasicPotluckAppData from "../../../utils/loadBasicPotluckAppData";
import ShopsAppFrame from "../../../components/ShopsAppFrame";
import Colors from "../../../utils/Colors";
import isUnlimited from "../../../utils/isUnlimited";
import promiseMap from "../../../utils/promiseMap";
import PlanBlock from "../../../components/PlanBlock";
import Button from "../../../components/Button";

const styles = (theme) => ({
  container: {
    minHeight: "100%",
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up("sm")]: {
      maxWidth: 400,
      marginLeft: "auto",
      marginRight: "auto",
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  planBlock: {
    marginTop: theme.spacing.unit * 2,
    backgroundColor: Colors.white,
  },
  cta: {
    marginTop: theme.spacing.unit * 6,
  },
});

class Plan extends Component {
  onClickCta = () => {
    this.props.router.push(`/s/${this.props.shop.descriptor}/checkout`);
  };

  render() {
    let planPeriod = "-";
    let planName = "未登録";
    let planTickets = this.props.wallet?.data?.normalTickets;
    let nextPlanPeriod = "-";
    let nextPlanName = "未登録";
    let nextPlanTickets = 0;

    if (this.props.wallet.data?.plan) {
      planPeriod = `${moment(this.props.wallet.data.plan.startsAt).format("YYYY/MM/DD HH:mm")} 〜 ${moment(this.props.wallet.data.plan.endsAt).format("YYYY/MM/DD HH:mm")}`;
      planName = this.props.wallet.data.plan.name;

      if (isUnlimited(this.props.wallet.data.plan)) {
        planTickets = "∞";
      }
    }

    if (this.props.wallet.data?.nextPlan) {
      nextPlanPeriod = `${moment(this.props.wallet.data.plan.endsAt).format("YYYY/MM/DD HH:mm")} ~`;
      nextPlanName = this.props.wallet.data.nextPlan?.name;

      if (isUnlimited(this.props.wallet.data.nextPlan)) {
        nextPlanTickets = "∞";
      } else {
        nextPlanTickets = this.props.wallet.data.nextPlan?.ticketQuantity;
      }
    }

    return (
      <ShopsAppFrame
        backgroundColor="gray"
        selectedKey="profile"
        shop={this.props.shop}
      >
        <div className={this.props.classes.container}>
          {this.props.wallet?.data?.plan && [
            <PlanBlock
              key="plan"
              period={planPeriod}
              name={planName}
              tickets={planTickets}
              className={this.props.classes.planBlock}
            />,
            <PlanBlock
              key="nextPlan"
              period={nextPlanPeriod}
              name={nextPlanName}
              tickets={nextPlanTickets}
              className={this.props.classes.planBlock}
            />,
          ]}
          <Button
            text={
              this.props.wallet?.data?.nextPlan?.id
                ? "プランの変更・解約"
                : "プランの変更"
            }
            className={this.props.classes.cta}
            onClick={this.onClickCta}
          />
        </div>
      </ShopsAppFrame>
    );
  }
}

const mapStateToProps = (state) => ({
  wallet: state.api.wallet.default,
});

const mapDispatchToProps = {};

const Page = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withRouter(Plan)));

Page.getInitialProps = async (context) => {
  let profile;
  let results;

  try {
    profile = await setCookieAndLoadProfile(context);

    if (!profile) {
      return redirect(context, `/s/${context.query.descriptor}`);
    }

    results = await promiseMap({
      shop: context.store.dispatch(
        getShopsAppByDescriptor(context.query.descriptor),
      ),
      data: loadBasicPotluckAppData(context, { loggedIn: !!profile }),
    });
  } catch (error) {
    console.log(error);
  }

  if (!results?.shop) {
    return redirect(context, "/");
  }

  if (results.shop.defaultOffer) {
    /*
     * Exreme hack: remove asap
     */
    if (
      results.shop.defaultOffer === "daikanyamapink" &&
      profile &&
      !profile.payjpid
    ) {
      context.store.dispatch(setDefaultOfferCode("daikanyamapink-trial"));
    } else {
      context.store.dispatch(setDefaultOfferCode(results.shop.defaultOffer));
    }
  }

  return {
    profile,
    shop: results.shop,
  };
};

export default Page;
